import { z } from 'zod';
import {
    IpxRbsWorkflowWebsiteScopeKind,
    type IpxRbsWorkflowAllowedWebsiteTemplateScope,
    type IpxRbsWorkflowOrganizationAllowedWebsiteScope,
    type IpxRbsWorkflowWebsiteScope,
} from '../rbs-ips-workflow.types';

export const IpxRbsWorkflowAllowedWebsiteTemplateScopeSchema: z.ZodType<IpxRbsWorkflowAllowedWebsiteTemplateScope> =
    z
        .object({
            kind: z.literal(IpxRbsWorkflowWebsiteScopeKind.ALLOWED_WEBSITE_TEMPLATE),
            allowed_website_template_uuid: z.string().uuid(),
        })
        .strict();

export const IpxRbsWorkflowOrganizationAllowedWebsiteScopeSchema: z.ZodType<IpxRbsWorkflowOrganizationAllowedWebsiteScope> =
    z
        .object({
            kind: z.literal(IpxRbsWorkflowWebsiteScopeKind.ORGANIZATION_ALLOWED_WEBSITE),
            organization_allowed_website_uuid: z.string().uuid(),
        })
        .strict();

export const IpxRbsWorkflowWebsiteScopeSchema: z.ZodType<IpxRbsWorkflowWebsiteScope> = z.union([
    IpxRbsWorkflowAllowedWebsiteTemplateScopeSchema,
    IpxRbsWorkflowOrganizationAllowedWebsiteScopeSchema,
]);
